var map = {
	"./favicon.png": "a171",
	"./logo.png": "4ffd",
	"./logo2.png": "440d",
	"./mastercard.png": "ff57",
	"./paypal.png": "7445",
	"./portefeulle.png": "f64a",
	"./quiz.png": "7f75",
	"./ross.png": "4c4d",
	"./ross2.png": "4f85",
	"./rossdevise.png": "e736",
	"./rosspiece.png": "3a99",
	"./rossprtit.png": "41ab",
	"./rossprtit2.png": "1c3b",
	"./visa.png": "073b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";